import React from 'react';
import enhance from './enhance';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

export const Toggle = ({ alt, onClick, src }) => (
  <img alt={alt} src={src} onClick={onClick} className={styles.toggle} />
);

Toggle.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
};

export default enhance(Toggle);
